// removed by extract-text-webpack-plugin
module.exports = {"button":"zQsiu1bnet5lYL-zfRMkh","full":"Ushl2cUwM7z3jQ4epHanh zQsiu1bnet5lYL-zfRMkh"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Button/styles.scss
 ** module id = 433
 ** module chunks = 0
 **/